var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDinersClubCard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 16,
  fill: "none",
  viewBox: "0 0 24 16"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 23.333,
  height: 15.333,
  x: 0.333,
  y: 0.333,
  fill: "#fff",
  stroke: "#D9DDE9",
  strokeWidth: 0.667,
  rx: 1.333
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0079BE",
  d: "M13.186 13c2.786.013 5.328-2.23 5.328-4.957C18.514 5.061 15.972 3 13.186 3h-2.398c-2.819-.001-5.14 2.061-5.14 5.043 0 2.728 2.321 4.97 5.14 4.957z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10.8 3.414c-2.577 0-4.664 2.05-4.665 4.578.001 2.528 2.088 4.576 4.665 4.577 2.576 0 4.664-2.05 4.664-4.577 0-2.529-2.088-4.577-4.664-4.578M7.843 7.992c0-.585.18-1.156.52-1.64.338-.482.818-.855 1.378-1.068V10.7A2.97 2.97 0 0 1 8.362 9.63a2.85 2.85 0 0 1-.519-1.638m4.015 2.708V5.284c.56.213 1.04.585 1.38 1.068a2.85 2.85 0 0 1 0 3.28c-.34.482-.82.855-1.38 1.068"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#0079BE",
  d: "M13.186 13c2.786.013 5.328-2.23 5.328-4.957C18.514 5.061 15.972 3 13.186 3h-2.398c-2.819-.001-5.14 2.061-5.14 5.043 0 2.728 2.321 4.97 5.14 4.957z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10.8 3.414c-2.577 0-4.664 2.05-4.665 4.578.001 2.528 2.088 4.576 4.665 4.577 2.576 0 4.664-2.05 4.664-4.577 0-2.529-2.088-4.577-4.664-4.578M7.843 7.992c0-.585.18-1.156.52-1.64.338-.482.818-.855 1.378-1.068V10.7A2.97 2.97 0 0 1 8.362 9.63a2.85 2.85 0 0 1-.519-1.638m4.015 2.708V5.284c.56.213 1.04.585 1.38 1.068a2.85 2.85 0 0 1 0 3.28c-.34.482-.82.855-1.38 1.068"
})));
export default SvgDinersClubCard;